import AboutHero from "./components/AboutHero"
import AboutUsCards from "./components/AboutUsCards"
import AboutSection3 from "./components/AboutSection3"
import { Form } from "../components"

export default function About() {
  return (
    <>
      <section>
        <AboutHero />
        <AboutUsCards />
        <AboutSection3 />

        <div className="bg-blue py-10 px-5 lg:py-20 2xl:px-0">
          <article className="xl:max-w-6xl xl:mx-auto">
            <h2 className="text-white text-3xl lg:text-5xl mb-5 lg:mb-10 lg:w-1/2 lg:leading-snug">
              Do you want to get to know us better?
            </h2>
            <Form />
          </article>
        </div>
      </section>
    </>
  )
}
